import { render, staticRenderFns } from "./33.vue?vue&type=template&id=1813eb0c&scoped=true&"
var script = {}
import style0 from "./33.vue?vue&type=style&index=0&id=1813eb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813eb0c",
  null
  
)

export default component.exports